import React from "react";
import { Booking } from "../booking/Booking.model";
import { ApiLinkedButtonV3 } from "../components/common/Form/ApiLinked.button.V3";
import { FormikSwitchInput } from "../components/common/input/FormikSwitch.input";
import { reloadWindowPromise } from "../components/common/reloadCallback";
import { VideoSessionApi } from "./VideoSessions.api";

interface VideoSessionRevertNoShowComponentProps {
  className?: string;
  booking: Booking;
}

export function VideoSessionRevertNoShowComponent(
  props: VideoSessionRevertNoShowComponentProps
) {
  return (
    <span className={`VideoSessionRevertNoShowComponent`}>
      <ApiLinkedButtonV3
        className={`btn-warning ${props.className}`}
        uniqueKey={`vs-${props.booking.id}-revert-no-show`}
        buttonProps={{
          content: { normal: `Revert No-Show` },
        }}
        api={VideoSessionApi.revertNoShow(props.booking.id!)}
        successCallback={reloadWindowPromise}
        apiFormBody={
          <div>
            Are you sure that you want to revert the no-show status for this session?
            <FormikSwitchInput
              name={"sendNotification"}
              label={`Do you want to send a notification for this reversal of no show?`}
              required={false}
            />
          </div>
        }
        formModalSize={"md"}
      />
    </span>
  );
}
